module.exports = __webpack_public_path__ + "static/img/lineEchart.2c441ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cockpitCh/lineEchart.png
// module id = OTTa
// module chunks = 31